import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import { useTheme } from '../context/useTheme';

export default function RadixThemeProvider({ children }) {
  const { theme } = useTheme();

  return (
    <Theme appearance={theme} accentColor="indigo" grayColor="slate" radius="large" scaling="100%">
      {children}
    </Theme>
  );
}
